import React from "react";
import {WeatherComponent} from "../components/weather/WeatherComponent";

const Main = () => {
    return(
            <WeatherComponent/>
    )
}

export default Main